import React, { useCallback, useRef, useState } from 'react';

import { useRouter } from 'expo-router';
import { logNavigationClick } from 'features/navigation/utils/analytics';
import { StyleSheet } from 'react-native';

import { ArrowButton } from 'components/arrow-button';
import { ArrowLink } from 'components/arrow-link';
import ConfirmDialog from 'components/confirm-dialog';
import { Box, Typography } from 'components/ui';
import { routes } from 'navigation/routing';
import { CustomEventNames } from 'state/amplitude';
import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { spacing } from 'styles/constants';

export const TermsSection = () => {
  const enableAccountDeleteOneTrust = useFlag(LaunchDarklyFlag.ENABLE_ACCOUNT_DELETE_ONE_TRUST);
  const pendingSignOutRef = useRef(false);
  const router = useRouter();
  const [showSignOutConfirmDialog, setShowSignOutConfirmDialog] = useState(false);

  const openSignOutConfirmDialog = useCallback(() => {
    setShowSignOutConfirmDialog(true);
  }, []);

  const closeSignOutConfirmDialog = useCallback(() => {
    pendingSignOutRef.current = false;
    setShowSignOutConfirmDialog(false);
  }, []);

  const handleConfirmSignOut = useCallback(() => {
    pendingSignOutRef.current = true;
    logNavigationClick(CustomEventNames.BUTTON_CLICK_SIGN_OUT);
    setShowSignOutConfirmDialog(false);
  }, []);

  const handleSignOutDialogAfterClose = useCallback(() => {
    if (!pendingSignOutRef.current) {
      return;
    }

    pendingSignOutRef.current = false;
    router.replace(routes.signOut);
  }, [router]);

  return (
    <Box style={styles.linkContainer}>
      <ArrowLink to={routes.privacyPolicy}>{t('privacyPolicy')}</ArrowLink>

      <ArrowLink to={routes.termsOfService}>{t('termsOfService')}</ArrowLink>

      <ArrowButton onPress={openSignOutConfirmDialog} testID="signout-button">
        <Typography>{t('signOut')}</Typography>
      </ArrowButton>
      {/* TODO Remove one legal approves the use of `enableAccountDeletePage` */}
      {enableAccountDeleteOneTrust && (
        <ArrowLink
          isExternal
          to={
            'https://privacyportal-eu-cdn.onetrust.com/dsarwebform/7ae425dd-1c76-46b0-a1b4-2422a364fae3/draft/1d4481aa-204a-4cb5-a40a-82e4369d16b2.html'
          }
          eventName={CustomEventNames.BUTTON_CLICK_ACCOUNT_DELETE_ONE_TRUST}
        >
          {t('deleteAccount')}
        </ArrowLink>
      )}

      <ConfirmDialog
        showDialog={showSignOutConfirmDialog}
        heading={t('signOut')}
        body={t('signOutConfirmSubheader')}
        confirmLabel={t('yes')}
        cancelLabel={t('no')}
        onConfirm={handleConfirmSignOut}
        onCancel={closeSignOutConfirmDialog}
        onDismiss={closeSignOutConfirmDialog}
        onAfterClose={handleSignOutDialogAfterClose}
        modalAppearanceEventMessage="Confirmation: Sign Out"
      />
    </Box>
  );
};

const styles = StyleSheet.create({
  linkContainer: {
    marginTop: spacing.$1,
  },
});
